"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuSimpleItem = exports.MenuSimple = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./pixelated.menu-simple.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /* eslint-disable */ /* eslint sonarjs/no-collapsible-if: 0 */
/* ========== MENU ========== */
class MenuSimple extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuItems: []
    };
  }
  generateMenuItems() {
    const myItems = [];
    for (const itemKey in this.props.menuItems) {
      myItems.push( /*#__PURE__*/_react.default.createElement(MenuSimpleItem, {
        key: itemKey,
        name: itemKey,
        href: this.props.menuItems[itemKey]
      }));
    }
    // this.setState({ menuItems: myItems })
    return myItems;
  }
  componentDidMount() {
    const menu = document.getElementById('menu');
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "menu-wrapper"
    }, /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("div", {
      className: "menu",
      id: "menu"
    }, /*#__PURE__*/_react.default.createElement("ul", null, this.generateMenuItems())), /*#__PURE__*/_react.default.createElement("hr", null));
  }
}

/* ========== MENU ITEM ========== */
exports.MenuSimple = MenuSimple;
_defineProperty(MenuSimple, "propTypes", {
  menuItems: _propTypes.default.object.isRequired
});
class MenuSimpleItem extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: "menu-item"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: this.props.href
    }, this.props.name));
  }
}
exports.MenuSimpleItem = MenuSimpleItem;
_defineProperty(MenuSimpleItem, "propTypes", {
  name: _propTypes.default.string.isRequired,
  href: _propTypes.default.string.isRequired
});